const { View } = require('@react-pdf/renderer')

const PDFCell = ({ children, flex, style }) => (
  <View
    style={{
      alignItems: 'center',
      justifyContent: 'center',
      border: '0.8px solid black',
      padding: 10,
      margin: -0.5,
      flex,
      ...style,
    }}
  >
    {children}
  </View>
)

export default PDFCell
